import React, { useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { fetchGoogleUsers } from "../../../services/GoogleUsersService";
import { useTranslation } from "react-i18next";

const GoogleUsers = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        setLoading(true);
        const response = await fetchGoogleUsers();
        setUsers(response.users || []);
        setError(null);
      } catch (err) {
        console.error("Error loading Google users:", err);
        setError(err.message || "Failed to load Google users");
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  return (
    <>
      <PageTitle activeMenu={t("Google Users") || "Google Users"} motherMenu={t("dashboard")} />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {t("Google Users") || "Google Users"}
              </h4>
              <p className="text-muted mb-0">
                {t("List of users who signed in with Google and placed orders") ||
                  "List of users who signed in with Google and placed orders"}
              </p>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              ) : users.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">
                    {t("No Google users found") || "No Google users found"}
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{t("Name") || "Name"}</th>
                        <th>{t("Email") || "Email"}</th>
                        <th>{t("Total Orders") || "Total Orders"}</th>
                        <th>{t("Last Order Date") || "Last Order Date"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user, index) => (
                        <tr key={user.email || index}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {user.picture && (
                                <img
                                  src={user.picture}
                                  alt={user.name}
                                  className="rounded-circle me-2"
                                  style={{ width: "32px", height: "32px" }}
                                />
                              )}
                              <span>{user.name || t("N/A") || "N/A"}</span>
                            </div>
                          </td>
                          <td>{user.email || t("N/A") || "N/A"}</td>
                          <td>
                            <span className="badge badge-primary">
                              {user.orderCount || 0}
                            </span>
                          </td>
                          <td>
                            {user.lastOrderDate
                              ? new Date(user.lastOrderDate).toLocaleDateString()
                              : t("N/A") || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoogleUsers;



